import DataToAction from "./DataToAction";

export { Page }

function Page() {
  return <DataToAction />;
}